import { useNavigate } from "react-router-dom";
import { useAppStore, type AppState } from "../store/useAppStore";
import { VIEW_TO_PATH } from "../routes/appRoutes";

export function useAppNavigate() {
  const navigate = useNavigate();
  const setCurrentView = useAppStore((state) => state.setCurrentView);

  return (view: AppState["currentView"]) => {
    setCurrentView(view);
    const path = VIEW_TO_PATH[view];
    if (path) {
      navigate(path);
    }
  };
}
